'use client'

import { clientPage } from '../../_lib/clientPage'

export default clientPage(() =>
  import('@/components/views/DonateView').then((m) => ({
    default: m.DonateView,
  }))
)
